import React from "react";
import * as Styled from "./TicketList.styled";
import { TicketCard } from "../TicketCard";
import Pagination from "react-bootstrap/Pagination";
import { NoTicketMessage } from "../no-ticket-message";
import { TicketListProps } from "../../../libs";

export const TicketList: React.FC<TicketListProps> = ({
    tickets,
    currentPage,
    lastEvaluatedKey,
    onNextPage,
    onPrevPage,
    onOpenTicket,
    isAdmin,
    paginationHistory,
    onNewTicketClick
}) => {

    return (
        <Styled.ListContainer>
            {tickets.length > 0 ? (
                tickets.map((ticket, index) => (
                    <TicketCard
                        key={ticket.ticketId || index}
                        ticket={ticket}
                        onOpenTicket={onOpenTicket}
                        isAdmin={isAdmin}
                    />
                ))
            ) : (
                <NoTicketMessage onNewTicketClick={onNewTicketClick} />
            )}

            <Styled.PaginationContainer>
                <Pagination>
                    <Pagination.Prev
                        onClick={onPrevPage}
                        disabled={paginationHistory.length === 0}
                    >
                        Previous
                    </Pagination.Prev>

                    <Pagination.Item active>{currentPage}</Pagination.Item>

                    <Pagination.Next
                        onClick={onNextPage}
                        disabled={lastEvaluatedKey === null}
                    >
                        Next
                    </Pagination.Next>
                </Pagination>
            </Styled.PaginationContainer>
        </Styled.ListContainer>
    );
};

export default TicketList;
